import axios from '../../config/axiosInstance';

export const usageLog = (path, companyId, userId, detailsJson) => {
  axios
    .post('/usageLog', {
      companyId: companyId,
      byUser: userId,
      path: path,
      detailsJson: detailsJson,
    })
};


export const urlplanInfo = (url) => {
  const planUrl = url.searchParams.get("plan");
  const pagamentoUrl = url.searchParams.get("Pagamento");
  const data = { planUrl, pagamentoUrl }
  return data;
};

